import StandardError from '@/modules/errors/Standard'

class SignInAccountNotFoundError extends StandardError {
  constructor(message = 'Account not found', status = 400, body = {}) {
    super(message)
    this.status = status
    this.body = body
  }
}
export default SignInAccountNotFoundError
